import { pluralizeWithCount } from "@common/helpers/string";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { CommandIslandTotal } from "@design-system/CommandIsland/CommandIslandTotal";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { Pagination } from "@design-system/Pagination/Pagination";
import historyDetailsStyles from "@components/history/details/HistoryDetails.module.scss";

interface OrganizationActivityChangesFooterProps {
    total: number;
    page: number;
    pageCount: number;
    onPageChange: (page: number) => void;
}

export const OrganizationActivityChangesFooter = ({
    total,
    page,
    pageCount,
    onPageChange,
}: OrganizationActivityChangesFooterProps) => (
    <CommandIsland
        sticky
        className={commandIslandStyles.bulkActionsStickyFooter}
    >
        <div className={historyDetailsStyles.footerLeft}>
            {pageCount > 1 && (
                <Pagination
                    size="md"
                    currentPage={page}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                />
            )}
            <CommandIslandTotal>
                {pluralizeWithCount("change", total)}
            </CommandIslandTotal>
        </div>
    </CommandIsland>
);
